"use client";

import { Hand, Leaf, Sprout } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FlexibleCareForYourLife() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    icon: Sprout,
    title: "Evidence-Based Care",
    description: "We utilize proven therapeutic techniques tailored to your unique journey, ensuring long-lasting and effective results."
  }, {
    icon: Hand,
    title: "Safe & Non-Judgmental",
    description: "A secure space where you are truly heard, respected, and supported as you navigate life's challenges."
  }, {
    icon: Leaf,
    title: "Flexible Support",
    description: "Offering individual, family, and couples therapy with convenient day, night, and telehealth options."
  }];
  return <section data-section-id="220" id="flexible-care-for-your-life" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32 lg:py-40">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/4 h-[600px] w-[600px] bg-accent opacity-70 blur-3xl" style={{
      borderRadius: "60% 40% 55% 45% / 50% 60% 40% 50%"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 bottom-0 h-[500px] w-[500px] bg-accent opacity-60 blur-3xl" style={{
      borderRadius: "45% 55% 40% 60% / 55% 45% 60% 40%"
    }} />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={headerRef} className={`mx-auto max-w-[900px] text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs md:text-sm uppercase tracking-[0.35em] text-accent-foreground">The TR mental health Promise</p>
          <h2 className="font-default mt-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] text-foreground">
            Reclaim your balance,{" "}
            <em className="italic font-light text-accent-foreground">together</em>,
            <br className="hidden sm:block" /> finding the life you{" "}
            <em className="italic font-light text-accent-foreground">deserve</em>
          </h2>

          {}
          <div className="mt-10 flex items-center justify-center gap-4">
            <span className="h-px w-12 bg-border" />
            <span className="h-1.5 w-1.5 rounded-lg bg-accent-foreground" />
            <span className="h-px w-12 bg-border" />
          </div>
        </div>

        {}
        <div ref={gridRef} className="relative mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-0">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className={`relative flex flex-col items-center text-center px-4 md:px-10 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: gridVisible ? `${i * 180}ms` : "0ms"
          }}>
                {}
                {i > 0 && <span aria-hidden="true" className="hidden md:block absolute left-0 top-6 bottom-6 w-px bg-border" />}

                {}
                <div className="relative mb-8 flex h-20 w-20 items-center justify-center">
                  <span aria-hidden="true" className="absolute inset-0 rounded-lg border border-accent-foreground/20" style={{
                borderRadius: "55% 45% 50% 50% / 50% 55% 45% 50%"
              }} />
                  <Icon strokeWidth={1} className="h-12 w-12 text-accent-foreground" />
                </div>

                <h3 className="font-default text-2xl md:text-[26px] leading-tight text-foreground">
                  {feature.title}
                </h3>
                <p className="font-default mt-4 max-w-xs text-sm md:text-base leading-relaxed text-foreground/70">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}